<template>
  <b-row>
      <b-col
          md="12"
          sm="12"
      >
        <b-row>
        <b-col
            md="3"
            sm="3"
            class="my-1"
        >

          <b-form-group
              class="mb-0"
          >
            <label class="d-inline-block text-sm-left mr-50">Per page</label>
            <b-form-select
                id="perPageSelect"
                v-model="perPage"
                size="sm"
                :options="pageOptions"
                class="w-50"
            />
          </b-form-group>
        </b-col>

          <b-col
              md="6"
              sm="6"
              class="my-1"
          >
          </b-col>
        <b-col
            md="3"
            sm="3"
            class="my-1 "
        >
          <b-form-group
              class="mb-0"
          >
            <b-button class="btn-info mb-0 btn-sm float-right" @click="RestartMailQueue">
              <b-spinner
                small
                variant="light"
                v-show="loading.resetQueue"
                class="mr-1"
            />Warteschlange erneut anstoßen</b-button>
          </b-form-group>
        </b-col>
        </b-row>
      </b-col>
    <b-col cols="12">
      <b-table
          striped
          hover
          responsive
          :items="items"
          :fields="fields"
      >
        <template #cell(MailId)="data">
          <b-form-checkbox
              v-model="data.item.Checked"
              class="custom-control-success"
          />{{data.item.MailId}}
        </template>
        <template #cell(DateTime)="data">
          {{ formatDate(data.item.DateTime) }} - {{ formatTime(data.item.DateTime) }} Uhr
        </template>
        <template #cell(State)="data">
          <b-badge
              pill
              variant="warning"
              v-show="data.item.State == 0"
          >
            In Warteschlange
          </b-badge>
          <b-badge
              pill
              variant="success"
              v-show="data.item.State == 1"
          >
            {{ formatDate(data.item.Send) }}
          </b-badge>
          <b-badge
              pill
              variant="danger"
              v-show="data.item.State == 2"
          >
            Unzustellbar {{ formatDate(data.item.Send) }}
          </b-badge>

        </template>
        <template #cell(Attachments)="data">
          {{ getAttachmentCount(data.item.Attachments) }}
        </template>
      </b-table>
    </b-col>

    <b-col
        cols="12"
    >
      <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="center"
          size="sm"
          class="my-0"
      />
    </b-col>
  </b-row>
</template>

<script>
import {
  BTable, BAvatar, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BAlert, VBTooltip, BFormDatepicker,
  BDropdown,
  BDropdownDivider,
  BDropdownForm,
  BDropdownGroup,
  BDropdownItem,
  BSpinner, BFormCheckbox,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BFormCheckbox,
    BTable,
    BAvatar,
    BAlert,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BFormDatepicker,
    BInputGroupAppend,
    BButton,
    BDropdown,
    BDropdownDivider,
    BDropdownForm,
    BDropdownGroup,
    BDropdownItem,
    BSpinner,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      perPage: 50,
      pageOptions: [10, 25, 50, 100],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      date: {
        from: '',
        to: ''
      },
      filter: null,
      filterOn: [],
      loading: {
        resetQueue: false
      },
      fields: [
        {
          key: 'MailId',
          label: 'Id',
        },
        {
          key: 'DateTime',
          label: 'Datum / Zeit',
        },
        {
          key: 'Recipient',
          label: 'Empfänger Adresse',
        },
        {
          key: 'Subject',
          label: 'Betreff',
        },
        {
          key: 'Attachments',
          label: 'Anhänge',
        },
        {
          key: 'State',
          label: 'Status',
        },
      ],
      items: [{
        Costomer: 'Wird geladen....'
      }],
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
          .filter(f => f.sortable)
          .map(f => ({
            text: f.label,
            value: f.key
          }))
    },

  },
  mounted() {
    this.$nextTick(() => {
      document.title = 'Maillog'
    })
    this.LoadList()

    this.$watch(
        () => this.currentPage,
        val => {
          this.LoadList()
        },
    )

    this.$watch(
        () => this.perPage,
        val => {
          const v = this
          if (this.filterTimeout) clearTimeout(this.filterTimeout)
          this.filterTimeout = setTimeout(() => {
            v.LoadList()
          }, 550)
        },
    )
    this.$watch(
        () => this.filter,
        val => {
          const v = this
          if (this.filterTimeout) clearTimeout(this.filterTimeout)
          this.filterTimeout = setTimeout(() => {
            v.LoadList(0)
          }, 550)
        },
    )
    // Set the initial number of items
    this.totalRows = this.items.length
  },
  methods: {
    getAttachmentCount(a) {
      if (a == null) {
        return 0
      }

      return Object.keys(a).length
    },
    formatDate(date) {
      return `${new Date(date).toLocaleString('de-DE', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
          },
      )}`
    },
    formatTime(date) {
      return `${new Date(date).toLocaleString('de-DE', {
            hour: '2-digit',
            minute: '2-digit',
          },
      )}`
    },
    RestartMailQueue() {
      if(this.loading.resetQueue == true) {
        return;
      }
      this.loading.resetQueue = true
      const list = []
      this.items.forEach(i => {
        if(i.Checked) {
          list.push(i.MailId)
        }
      })
      this.$http.post("mail/send/queue", JSON.stringify({"MailList": list}))
          .then(resp => {
            if(resp.data.success) {
              setTimeout(() => {
                this.loading.resetQueue = false;
                this.LoadList();
              }, 3550)
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Info',
                  icon: 'CheckIcon',
                  text: 'Warteschlange wurde angestoßen.',
                  variant: 'success',
                },
              })
            }
          })
          .catch(err => {
            console.error(err)
          })
    },
    LoadList() {
      this.items = []
      const c1 = (this.currentPage - 1) * this.perPage
      let url = `/mail/list?from=${c1}&count=${this.perPage}`
      if (this.filter && this.filter !== '') {
        url += `&filter=${this.filter}`
      }
      this.$http.get(url)
          .then(resp => {
            this.totalRows = resp.data.info.fullEntries
            resp.data.list.forEach(i => {

              this.items.push(i.Value)
            })
          })
          .catch(err => {
            console.error(err)
          })
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
}
</script>
